import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { getCardById } from '../use';

const { registerReducer } = useStorymapStore();

export class CardSelectionChanged extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'CardSelectionChanged';

    public constructor(public cardId: string, public userFullName: string) {
        super(CardSelectionChanged.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CardSelectionChanged): void => {
    if (action.isDispatchedByRealTimeCallback) {
        // remove user from previous card while keeping the original activeusers array in place so watchers can detect the change
        const previousCard = state.navigationState.activeCardsByOtherUsers[action.userFullName];
        if (previousCard) {
            const index = previousCard.activeUsers.indexOf(action.userFullName);
            if (index !== -1) {
                previousCard.activeUsers.splice(index, 1);
            }
            state.navigationState.activeCardsByOtherUsers[action.userFullName] = null;
        }

        // add new user selecton to card
        const card = getCardById(action.cardId);
        if (!card) {
            return;
        }

        card.activeUsers.push(action.userFullName);
        state.navigationState.activeCardsByOtherUsers[action.userFullName] = card;
    }
};

//@ts-ignore
registerReducer(CardSelectionChanged.ACTION_TYPE, reducer);
